import {
  lifecycle,
  compose
} from 'recompose';
import {createSelector} from 'reselect';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';

import {setWrappedDisplayName} from '@ciscospark/react-component-utils';
import {fetchCurrentUser} from '@ciscospark/redux-module-users';

const getUsers = (state) => state.users;

const getCurrentUser = createSelector(
  [getUsers], (users) => {
    const currentUserId = users.get('currentUserId');

    return {
      currentUser: users.getIn(['byId', currentUserId])
    };
  }
);

function fetchUser(props) {
  const {spark, users} = props;

  if (spark &&
    spark.getIn(['status', 'registered']) &&
    !users.get('currentUserId')
  ) {
    const sparkInstance = spark.get('spark');

    props.fetchCurrentUser(sparkInstance);
  }
}

export default compose(
  setWrappedDisplayName('WithCurrentUser'),
  connect(
    getCurrentUser,
    (dispatch) => bindActionCreators({
      fetchCurrentUser
    }, dispatch)
  ),
  lifecycle({
    componentDidMount() {
      fetchUser(this.props);
    },
    componentWillReceiveProps(nextProps) {
      fetchUser(nextProps);
    }
  })
);
